module.exports = __webpack_public_path__ + "files/c60f90e12e6ba014bab19d8e0892d57f.png";